import { render, staticRenderFns } from "./VehicleEvents.vue?vue&type=template&id=bbd5b3e6&"
import script from "./VehicleEvents.vue?vue&type=script&lang=js&"
export * from "./VehicleEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports